import { baseURL } from "../../../Shared/Networking/constants";
import { internalServerError, makeRequest } from "../../../Shared/Networking/rest-client";

export async function signupWithCredentials(credentials) {
    const url = `${baseURL}/authentication/signup`;
    const response = await makeRequest(url, { method: 'POST', body: credentials })
    if (response.status !== 201 && response.status !== 500) {
        const { message } = await response.json()
        throw Error(message)
    } else if (response.status === 500) {
        throw internalServerError()
    }
}